/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {

    init: function() {
      const form = document.querySelector( '#product-filter' );

      function shopFilter( query ) {
        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'woocommerce/filter',
          data: query,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            const target = $( '#shop .shop-grid' );
            target.html( data );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }


      document.addEventListener( 'click', ( event ) => {
        if ( !event.target.matches( '.shop-nav-btn' ) ) return;

        if ( event.target.matches( '.shop-nav-btn' ) ) {
          const page = event.target.dataset.value;
          const urlQuery = new URLSearchParams( window.location.search );
          urlQuery.set( 'page', page );
          history.replaceState( '', '', '?'+decodeURIComponent( urlQuery.toString() ) );
          shopFilter( urlQuery.toString() );
          document.getElementById( 'shop' ).scrollIntoView( {behavior: 'smooth', block: 'start'} );
        }
      } );

      document.querySelectorAll( '.filter-term' ).forEach( ( input ) => {
        input.addEventListener( 'change', () => {
          form.requestSubmit();
        } );
      } );

      form.addEventListener( 'submit', ( event ) => {
        event.preventDefault();
        const formData = new FormData( event.target );
        const urlQuery = new URLSearchParams( formData );
        history.replaceState( '', '', '?'+decodeURIComponent( urlQuery.toString() ) );
        shopFilter( urlQuery.toString() );
      } );

      if ( window.location.search ) {
        shopFilter( new URLSearchParams( window.location.search ).toString() );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'shop-filter', COMPONENT );
} )( app );
